import { forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';

import { StackAlign, StackProps } from './types';

const alignClasses: Record<StackAlign, string> = {
  top: 'stack-top',
  bottom: 'stack-bottom',
  start: 'stack-start',
  end: 'stack-end',
};

export const Stack = forwardRef<HTMLDivElement, StackProps>(
  ({ className, align, children, ...props }, ref) => {
    const classes = twMerge('stack', align && alignClasses[align], className);

    return (
      <div ref={ref} className={classes} {...props}>
        {children}
      </div>
    );
  },
);

Stack.displayName = 'Stack';
